import React, { useState, useEffect, useRef } from 'react';
import FadeIn from './FadeIn';
import WeddingFlow from './WeddingFlow';
import { useImagePreloader } from '../hooks/useImagePreloader';

const galleryPhotos = [
  "https://ik.imagekit.io/aeu02xvjgn/Ad%20Images/220609_W_Newmann-0496.jpg",
  "https://ik.imagekit.io/aeu02xvjgn/Ad%20Images/01-details%20padua%20hills%20theatre-179.jpg",
  "https://ik.imagekit.io/aeu02xvjgn/Ad%20Images/_MG_7189%20E1.jpg",
];

const TransitionCarousel = () => {
  const [current, setCurrent] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setCurrent(c => (c + 1) % galleryPhotos.length);
    }, 4000);
    return () => clearInterval(timerRef.current);
  }, []);

  return (
    <div className="relative w-full overflow-hidden" style={{ height: '60vh' }}>
      {galleryPhotos.map((src, i) => (
        <div
          key={i}
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('${src}')`,
            opacity: i === current ? 1 : 0,
            transition: 'opacity 1s ease-in-out',
            willChange: 'opacity',
          }}
        />
      ))}
      <div
        className="absolute top-0 left-0 right-0 z-10 pointer-events-none"
        style={{ height: '160px', background: 'linear-gradient(to bottom,#FCFAF6 0%,transparent 100%)' }}
      />
      <div
        className="absolute bottom-0 left-0 right-0 z-10 pointer-events-none"
        style={{ height: '160px', background: 'linear-gradient(to top,rgba(245,240,230,0.95) 0%,transparent 100%)' }}
      />
      <div className="absolute inset-0 z-20 flex flex-col items-center justify-center pointer-events-none">
        <div className="bg-brand-charcoal/30 backdrop-blur-sm px-8 py-5 text-center">
          <span className="text-brand-vintage/70 uppercase tracking-[0.5em] text-[9px] font-bold block mb-2">Real Celebrations</span>
          <p className="font-serif text-brand-vintage text-2xl md:text-3xl font-light italic">Every love story is unique</p>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2 z-20">
        {galleryPhotos.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            aria-label={`Slide ${i + 1}`}
            className={`h-1 rounded-full transition-all duration-500 ${i === current ? 'bg-brand-vintage w-8' : 'bg-brand-vintage/40 w-2'}`}
          />
        ))}
      </div>
    </div>
  );
};

const Weddings = () => {
  useImagePreloader(galleryPhotos, true);

  return (
    <section id="weddings" className="bg-brand-vintage">
      <div className="max-w-7xl mx-auto px-6 pt-24 md:pt-32">
        <div className="flex flex-col md:flex-row gap-12 md:gap-20 items-center mb-24">
          <FadeIn className="w-full md:w-1/2">
            <span className="text-brand-bronze uppercase tracking-[0.3em] text-[10px] font-bold mb-4 block">The Experience</span>
            <h2 className="font-serif text-3xl md:text-5xl text-brand-charcoal mb-8 leading-tight font-light">
              Some venues give you a room. <br />
              <span className="italic text-brand-olive font-light underline decoration-brand-stone/30 underline-offset-8">
                Padua gives you a feeling.
              </span>
            </h2>
            <p className="font-sans text-brand-charcoal/80 leading-relaxed font-light mb-6 text-lg">
              There is a specific kind of magic that happens at Padua. It starts with the scenic arrival through historic olive groves and carries through to the romantic ceremony atmosphere under the Southern California sky.
            </p>
            <p className="font-sans text-brand-charcoal/70 leading-relaxed font-light text-base">
              Our venue is designed for the couple who values both beauty and guest experience. With indoor/outdoor flexibility and timeless architecture, we provide the perfect foundation for memories that last a lifetime.
            </p>
          </FadeIn>
          <FadeIn delay={0.2} className="w-full md:w-1/2 relative">
            <div className="aspect-[4/5] overflow-hidden rounded-sm shadow-[40px_40px_0px_0px_rgba(217,204,186,0.2)]">
              <img
                src="https://ik.imagekit.io/aeu02xvjgn/21-BBR63144.jpg?updatedAt=1776889999898"
                alt="Wedding Couple at Padua Hills Theatre"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </FadeIn>
        </div>
      </div>
      <TransitionCarousel />
      <WeddingFlow />
    </section>
  );
};

export default Weddings;